<ph-stack gap="tight">
    <ph-toolbar justify="between">
        <ph-label>{{ section.label }}</ph-label>
        <ph-link-button
            *ngIf="section.editable && !inEditMode"
            (click)="enterEditMode()">
            Edit
        </ph-link-button>
    </ph-toolbar>

    <ph-card flat *ngIf="!inEditMode" [heading]="displaySubject">
        <ph-stack gap="tight">
            <ph-rich-text size="sm" [html]="displayBody"></ph-rich-text>
            <ph-hint *ngIf="section.footnote" [innerHTML]="section.footnote.text"></ph-hint>
        </ph-stack>
    </ph-card>

    <ph-card flat *ngIf="inEditMode" [formGroup]="form">
        <ph-stack>
            <ph-field>
                <ph-label>Subject</ph-label>
                <ph-input
                    formControlName="subject"
                    ngDefaultControl
                    aria-label="Subject">
                </ph-input>
            </ph-field>
            <ph-field>
                <ph-label>Message</ph-label>
                <app-rich-text-editor
                    [formGroup]="$any(form)"
                    controlName="body"
                    type="compact"
                    [useNewStyles]="true"
                    [isLoading]="false"
                    placeholder="Write the email body…"
                    [additionalInsertFields]="['first_name']">
                </app-rich-text-editor>
            </ph-field>
        </ph-stack>
        <ph-actions slot="footer">
            <ph-button variant="secondary" mode="filled" size="small" (click)="cancelEdit()">Cancel</ph-button>
            <ph-button size="small" icon="check" (click)="saveEdit()">Save changes</ph-button>
        </ph-actions>
    </ph-card>
</ph-stack>
